import script from "./Payouts.vue?vue&type=script&setup=true&lang=js"
export * from "./Payouts.vue?vue&type=script&setup=true&lang=js"

import "./Payouts.vue?vue&type=style&index=0&id=1320a802&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1320a802"]])

export default __exports__